import styled from 'styled-components';

export const PaddingDiv = styled.div`
	padding-left: calc(54% - 200px);
	padding-top: 100px;
	padding-right: calc(54% - 200px);
`;
